import React, { useEffect, useState } from 'react'
import '../css/TimesBar.scss'

const TimesBar = ({ times, activeYear, scrollToTime, narrType }) => {

  const [timesArray, setTimesArray] = useState([])
  const [yearsArray, setYearsArray] = useState([])

  useEffect(() => {
    isDup()
  }, times)

  const isDup = () => {
    let newArray = []
    let years = []

    times.forEach(element => {
      if (newArray[element.year]) {
        newArray[element.year].push(element)
      } else {
        newArray[element.year] = [element]
      }
      years.push(element.year)
    })

    const uniqueYearSet = new Set(years)
    const uniqueYearsArray = [...uniqueYearSet]

    setTimesArray(newArray)
    setYearsArray(uniqueYearsArray)
  }

  const activeIndex = yearsArray.indexOf(activeYear.year)
  const yTransform = 100 / (yearsArray.length - 1) * activeIndex

  return <div className={'narrTimesBar'} style={{ transform: `translateY(-${yTransform}%)` }}>
    {timesArray.map((times, index) => {
      return times.length === 1
        ? <TimesBarPoint
          scrollToTime={scrollToTime}
          time={times[0]}
          index={yearsArray.indexOf(times[0].year)}
          active={activeYear.key === times[0].key}
          total={yearsArray.length - 1}
          key={`time-point-${index}`}
        />
        : <DuplicateTimesBarPoint
          scrollToTime={scrollToTime}
          times={times}
          index={yearsArray.indexOf(times[0].year)}
          active={activeYear.year === times[0].year}
          activeKey={activeYear.key}
          total={yearsArray.length - 1}
          key={`time-point-${index}`}
        />
    })}
  </div>
}

const TimesBarPoint = ({ time, index, total, active, scrollToTime }) => {
  return <div
    onClick={() => scrollToTime(time)}
    className={`times-bar-point ${active ? 'active' : ''}`}
    style={{ top: `${getPointY(index, total)}%` }}
  >
    <div className='times-bar-point_time timeline-hover'>{time.year}</div>
  </div>
}

const DuplicateTimesBarPoint = ({ times, index, total, active, activeKey, scrollToTime }) => {
  return <div
    onClick={() => active ? undefined : scrollToTime(times[0])}
    className={`times-bar-point ${active ? 'active' : ''}`}
    style={{ top: `${getPointY(index, total)}%` }}
  >
    <div className='times-bar-point_time timeline-hover'>{times[0].year}</div>
    <div className={`times-bar-point_collection ${active ? 'show' : 'hide'}`}>
      {times.map((time, index) => {
        return <div
          className={`${active ? 'show' : 'hide'} duplicate-narrative ${time.key === activeKey ? 'active' : ''}`}
          onClick={() => scrollToTime(times[index])}
          key={`${time.key}-${index}`}
          style={{transitionDelay: `${.15 * index}s`}}
        >{time.industry_key.replace('_', ' ').toUpperCase()}</div>
      })}
    </div>
  </div>
}

const getPointY = (index, total) => (100 / total) * index


export default TimesBar
